import { h } from 'preact';
import * as BaseComp from 'base/bolt/boltApp.js';
import 'store/customTracking';
// import s from 'base/bolt/boltApp.sss';

export default class BoltApp extends BaseComp.default {

	// componentDidMount() {
	// 	super.componentDidMount();

	// 	const viewport = document.querySelector('meta[name=viewport]');
	// 	viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0');
	// }
}